module.exports = __webpack_public_path__ + "img/patch-question.7ebd0dd4.svg";